import type { GetApiV1ThreeLetterCodePartnerAdminsContractPlans200 } from '@fukuri-admins/apis/client/gen/model';

type IConvertToContractPlanOptions = (
  data: GetApiV1ThreeLetterCodePartnerAdminsContractPlans200
) => { value: string; label: string }[];

/**
 * 契約プラン一覧レスポンスを Select 用の選択肢に変換する
 *
 * - discontinued_at === 0 のプランのみ（廃止済みを除外）
 * - PartnerAdmin 版はパートナー販売手数料・Leafea収益単価を含まないため、名前のみ表示
 */
export const convertToContractPlanOptions: IConvertToContractPlanOptions = data =>
  data.contract_plans
    .filter(plan => plan.discontinued_at === 0)
    .map(plan => ({
      value: String(plan.id),
      label: plan.name,
    }));
